// assets/your-custom-script.js

let pageLayoutInitialized = false;
let judgeMeRowStarsReordered = false; // Flag specifically for JD stars row reordering
let observerSetupComplete = false;
let observerCheckInterval = null;
let observerCheckAttempts = 0;
const MAX_OBSERVER_CHECK_ATTEMPTS = 50;

// Function specifically for reordering JD stars row
function reorderJudgeMeStarsRow(starsRowContainer) {
    if (judgeMeRowStarsReordered || !starsRowContainer) return false; // Don't re-run if already done or no container
    console.log('Attempting Judge.me stars row reorder...');

    // Find elements within the stars row container
    const histogram = starsRowContainer.querySelector('.jdgm-histogram');
    const summary = starsRowContainer.querySelector('.jdgm-rev-widg__summary');
    // const actionsWrapper = starsRowContainer.querySelector('.jdgm-widget-actions-wrapper'); // No need to move this one relative to others

    if (histogram && summary) {
        // Check if histogram is NOT already the first direct child element (or before summary)
        // A simple check is if summary is currently the first element among the two important ones
        if (starsRowContainer.firstElementChild === summary || summary.previousElementSibling === null) { // Checking if summary is first, or has no preceding sibling
            console.log('Reordering Judge.me stars row: Moving histogram before summary.');
            // Move histogram before summary
            starsRowContainer.insertBefore(histogram, summary);
            judgeMeRowStarsReordered = true; // Set flag
            return true;
        } else {
             console.log('Judge.me histogram already correctly positioned before summary.');
             judgeMeRowStarsReordered = true; // Set flag even if already ordered
             return true;
        }
    } else {
        console.warn('Could not find histogram or summary within Judge.me stars row for reordering.');
        return false;
    }
}


// Function for other page layout changes (run once on DOMContentLoaded)
function initializeBasePageLayout() {
    // ... (keep the base layout logic exactly as before: moving title/price/app blocks) ...
    if (pageLayoutInitialized) return;
    console.log('Running initializeBasePageLayout...');
    const targetDiv = document.querySelector('.title-rating');
    const titlePriceBlock = document.querySelector('.product__block.product__title-and-price');
    const appBlock = document.querySelector('.product__block.standard__app'); // <<< VERIFY SELECTOR
    if (targetDiv) {
         if (titlePriceBlock && titlePriceBlock.parentNode !== targetDiv) { targetDiv.appendChild(titlePriceBlock); console.log('Moved title/price block.'); }
         if (appBlock && appBlock.parentNode !== targetDiv) { targetDiv.appendChild(appBlock); console.log('Moved app block.'); }
    } else { console.warn('Page-wide: Target .title-rating div not found.'); }
    pageLayoutInitialized = true;
    console.log('initializeBasePageLayout complete.');
}

// --- Function to setup the observer ---
function setupJudgeMeObserver() {
    if (observerSetupComplete) {
         if(observerCheckInterval) clearInterval(observerCheckInterval);
         return;
    }

    const judgeMePlaceholderSelector = '#judgeme_product_reviews'; // <<< Double-check this selector!
    const judgeMeContainer = document.querySelector(judgeMePlaceholderSelector);

    observerCheckAttempts++;

    if (judgeMeContainer) {
        console.log(`Judge.me container (${judgeMePlaceholderSelector}) FOUND after ${observerCheckAttempts} attempts. Setting up MutationObserver.`);
        if(observerCheckInterval) clearInterval(observerCheckInterval);
        observerSetupComplete = true;

        const observer = new MutationObserver((mutationsList, observerInstance) => {
            // Now look for the STARS ROW container specifically
            const starsRowContainer = judgeMeContainer.querySelector('.jdgm-row-stars');
            if (starsRowContainer) {
                console.log('Judge.me stars row detected by MutationObserver.');
                 // Check if histogram and summary also exist within it before attempting reorder
                if (starsRowContainer.querySelector('.jdgm-histogram') && starsRowContainer.querySelector('.jdgm-rev-widg__summary')) {
                    if (reorderJudgeMeStarsRow(starsRowContainer)) { // Try to reorder
                        console.log('Judge.me stars row reorder successful via observer. Disconnecting.');
                        observerInstance.disconnect(); // Stop observing once done
                    }
                } else {
                    // console.log('Histogram or summary not yet present within stars row.'); // Wait for next mutation
                }
            }
        });
        observer.observe(judgeMeContainer, { childList: true, subtree: true });

        // Initial check inside the container now that we know it exists
         const initialStarsRow = judgeMeContainer.querySelector('.jdgm-row-stars');
         if (initialStarsRow && initialStarsRow.querySelector('.jdgm-histogram') && initialStarsRow.querySelector('.jdgm-rev-widg__summary')) {
             if(reorderJudgeMeStarsRow(initialStarsRow)) {
                 console.log('Judge.me stars row reorder successful on initial check. Disconnecting observer.');
                 observer.disconnect();
             }
         }

    } else if (observerCheckAttempts >= MAX_OBSERVER_CHECK_ATTEMPTS) {
         console.warn(`Judge.me container (${judgeMePlaceholderSelector}) not found after ${MAX_OBSERVER_CHECK_ATTEMPTS} attempts. Stopping checks.`);
         if(observerCheckInterval) clearInterval(observerCheckInterval);
    } else {
         // console.log(`Judge.me container (${judgeMePlaceholderSelector}) not found yet (Attempt ${observerCheckAttempts}). Will check again.`); // Less noisy logging
    }
}


// --- Trigger base layout changes on DOMContentLoaded ---
 if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBasePageLayout);
} else {
    initializeBasePageLayout();
}

// --- Start polling to setup the Judge.me observer ---
function startObserverPolling() {
    if (observerSetupComplete) return;
    setupJudgeMeObserver(); // Initial immediate check
    if (!observerSetupComplete) {
        console.log('Starting polling for Judge.me container...');
        observerCheckInterval = setInterval(setupJudgeMeObserver, 100);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserverPolling);
} else {
    startObserverPolling();
}